import { createAsyncThunk } from '@reduxjs/toolkit';
import { OrderingOperations, OrderingSelectors } from 'polygon-ordering';

import debug from '../utils/debug';
import history from '../history';
import getDeviceTypeMobile from '../selectors/getDeviceTypeMobile';
import type { RootState } from 'store';
import getConfig from '../selectors/getConfig';
import { MENU_SCREEN_ROUTE, PICK_BRAND_SCREEN_ROUTE } from '../hooks/useRoutes';

const { applyBuffer } = OrderingOperations;
const { getLocationBrandsWithMenuRepresentation, getBypassDeliveryDetails } = OrderingSelectors;

export const applyBufferDeliveryEstimate = createAsyncThunk(
  'applyBufferDeliveryEstimate',
  async (_data: undefined, { dispatch, getState, rejectWithValue }) => {
    debug('applying buffered delivery estimate');

    try {
      await dispatch(applyBuffer()).unwrap();
      const representedBrands = getLocationBrandsWithMenuRepresentation(
        getState() as EntireFrontendState,
      );
      const bypassDeliveryDetails = getBypassDeliveryDetails(getState() as EntireFrontendState);

      const modalParams = (getState() as RootState).modalParams;

      const multipleBrands = representedBrands.length > 1;

      const deviceTypeMobile = getDeviceTypeMobile(getState() as RootState);
      const enableBrandSelection = getConfig(getState() as RootState).enableBrandSelection;
      const showBrandPicker = deviceTypeMobile && enableBrandSelection && multipleBrands;

      if (!bypassDeliveryDetails && modalParams?.allowRedirect !== false) {
        history.replace(showBrandPicker ? PICK_BRAND_SCREEN_ROUTE : MENU_SCREEN_ROUTE);
      }
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
